export default __webpack_public_path__ + "static/media/ls_overlay.5d1e6cdd.png";